/*
** With Slick Slider Plugin : https://github.com/marvinhuebner/slick-animation
** And Slick Animation Plugin : https://github.com/marvinhuebner/slick-animation
*/

// Init slick slider + animation
$('.block-img-slider').slick({
  autoplay: true,
  speed: 1000,
  lazyLoad: 'progressive',
  arrows: false,
  dots: false,
  pauseOnHover:false
}).slickAnimation();



 $(document).on("click" , ".block_menu-leval-two" ,function(){
  $(this).parents(".block_menu-leval-two-outer").find(".block_menu-leval-last").slideToggle();
   $(this).toggleClass("active")

})


  $(".block_our-commit-inner").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    adaptiveHeight: true,
    centerMode: false,
    arrows: true,
    prevArrow: $(".block_our-commit-prew-arrow"),
    nextArrow: $(".block_our-commit-next-arrow"),
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 749,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '20px',
        },
      }
    ],
  });